import {
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
    QueryList,
    ViewChildren,
    OnDestroy,
    HostListener,
} from "@angular/core";
import {ActivatedRoute, Router, Params} from "@angular/router";
import {
    OpenVidu,
    Session,
    Stream,
    StreamEvent,
    Publisher,
    SignalOptions,
    StreamManagerEvent,
} from "openvidu-browser";
import {ChatComponent} from "../components/chat/chat.component";
import {
    OpenViduLayout,
    OpenViduLayoutOptions,
} from "../components/layout/openvidu-layout";
import {UserModel} from "../../../services/models/user-model";
import {AlertController, ModalController, Platform} from "@ionic/angular";
import {OpenViduService} from "../service/openvidu.service";
import {
    fadeInOnEnterAnimation,
    fadeOutOnLeaveAnimation,
    fadeOutRightOnLeaveAnimation,
    fadeInLeftOnEnterAnimation,
    fadeInUpBigOnEnterAnimation,
} from "angular-animations";
import {
    trigger,
    keyframes,
    state,
    style,
    transition,
    animate,
} from "@angular/animations";
import {StreamComponent} from "../components/stream/stream.component";
import {CoachService} from "../../coach/service/coach.service";
import {CoachSessionModel} from '../../coach/models/session.model';
import {UserService} from "../../../services/user.service";
import {UserInfoModel} from "../../../services/models/user-info.model";
import {AuthService} from "../../../services/auth.service";
import {NavService} from '../../../services/nav.service';

declare var cordova;

@Component({
    selector: "app-video-chat-page",
    templateUrl: "./video-chat.page.html",
    styleUrls: ["./video-chat.page.scss"],
    animations: [
        fadeInOnEnterAnimation({anchor: "enter", duration: 500}),
        fadeOutOnLeaveAnimation({anchor: "leave", duration: 500}),
        fadeOutRightOnLeaveAnimation({anchor: "leaveList", duration: 300}),
        fadeInLeftOnEnterAnimation({anchor: "enterList", duration: 300}),
        fadeInUpBigOnEnterAnimation({anchor: "enterUp", duration: 300}),
        trigger("slideLeftRight", [
            state(
                "in",
                style({
                    transform: "translateX(0px)",
                })
            ),
            state(
                "out",
                style({
                    transform: "translateX(100px)",
                })
            ),
            transition(
                "in => out",
                animate(
                    "200ms",
                    keyframes([
                        style({transform: "translateX(100px)", display: "none"}),
                    ])
                )
            ),
            transition(
                "out => in",
                animate("200ms", keyframes([style({transform: "translateX(0px)"})]))
            ),
        ]),
        trigger("slideLeftRightChat", [
            state(
                "in",
                style({
                    transform: "translateX(0px)",
                })
            ),
            state(
                "out",
                style({
                    transform: "translateX(100px)",
                })
            ),
            transition(
                "in => out",
                animate(
                    "200ms",
                    keyframes([
                        style({transform: "translateX(100px)", display: "none"}),
                    ])
                )
            ),
            transition(
                "out => in",
                animate("200ms", keyframes([style({transform: "translateX(0px)"})]))
            ),
        ]),
        trigger("slideTopBottom", [
            state(
                "in",
                style({
                    transform: "translateY(0px)",
                })
            ),
            state(
                "out",
                style({
                    transform: "translateY(100px)",
                })
            ),
            transition(
                "in => out",
                animate(
                    "200ms",
                    keyframes([
                        style({transform: "translateY(100px)", display: "none"}),
                    ])
                )
            ),
            transition(
                "out => in",
                animate("200ms", keyframes([style({transform: "translateY(0px)"})]))
            ),
        ]),
    ],
})
export class VideoChatPage implements OnInit, OnDestroy {

    @ViewChild('layout') layout: ElementRef;

    // Constants
    ANDROID_PERMISSIONS = [
        "android.permission.CAMERA",
        "android.permission.RECORD_AUDIO",
        "android.permission.MODIFY_AUDIO_SETTINGS",
    ];
    BIG_ELEMENT_CLASS = "OV_big";

    buttonsVisibility = "in";
    chatNotification = "in";
    cameraBtnColor = "light";
    camBtnColor = "light";
    camBtnIcon = "videocam";
    micBtnColor = "light";
    micBtnIcon = "mic";
    chatBtnColor = "light";
    bigElement: HTMLElement;

    modalIsPresented = false;
    setUpModalIsPresented = true;

    audioDevice: any;
    audioDevices: any[] = [];
    videoDevices: any[] = [];
    speakerphone = false;

    showDocs = false;
    showNotes = false;
    showChat = false;
    showSettingUp = false;

    runSession = false;
    sessionId = null;
    currentSession: CoachSessionModel = null;
    userInfo: UserInfoModel = null;
    userType: string = null;
    recordingStarted = false;

    showAwaitUser = false;
    currentParticipant = null;
    currentCoach = null;
    currentParticipantId = null;
    currentCoachId = null;
    currentUserId = null;
    sessionStarted = false;
    selfName = null;
    selfRole = null;
    otherName = null;
    otherRole = null;
    disableMic = true;
    disableVid = true;

    secTotal = 0;
    secLeft = 0;
    timerTrigger = false;
    timerTimeout;

    sessionSecTotal = 0;
    sessionSecLeft = 0;
    exitSessionTimeout;

    OV: OpenVidu;
    @ViewChild("mainStream", {static: false}) mainStream: ElementRef;
    session: Session;
    openviduLayout: OpenViduLayout;
    openviduLayoutOptions: OpenViduLayoutOptions;
    mySessionId: string;
    myUserName: string;
    localUser: UserModel;
    remoteUsers: UserModel[];
    resizeTimeout;

    recording;

    @ViewChildren("streamComponentRemotes")
    streamComponentRemotes: QueryList<StreamComponent>;
    @ViewChild("streamComponentLocal", {static: false})
    streamComponentLocal: StreamComponent;

    @HostListener("window:beforeunload")
    beforeunloadHandler() {
        this.exitSession();
    }

    @HostListener("window:resize", ["$event"])
    sizeChange(event) {
        clearTimeout(this.resizeTimeout);
        this.updateLayout();
    }

    constructor(
        private route: ActivatedRoute,
        private coachService: CoachService,
        private router: Router,
        public modalController: ModalController,
        public platform: Platform,
        private openViduSrv: OpenViduService,
        public alertController: AlertController,
        public userService: UserService,
        private authService: AuthService,
        private nav: NavService
    ) {
        console.log('VideoChatPage.constructor')
    }

    ngOnInit() {
        console.log('VideoChatPage.ngOnInit')

        this.currentSession = this.route.snapshot.data.sessionInfo;

        this.sessionId = parseInt(this.route.snapshot.paramMap.get("sessionId"), 10);
        this.mySessionId = this.sessionId.toString();

        this.userType = this.authService.getUserType() === 'coach' ? 'coach' : 'delegate';
        // this.currentU = this.userService.getCurrentUserInfo(false).full_name;

        this.localUser = new UserModel();
        //this.localUser.setAudioSource(this.openViduSrv.getAudioDeviceId());
        //this.localUser.setVideoSource(this.openViduSrv.getVideoDeviceId());

        this.userService.getUserInfo().then((data: UserInfoModel) => {
            this.userInfo = data;
            this.myUserName = this.userInfo.full_name;

            // if (this.sessionId < 1) {
            //     this.router.navigate(['/team']);
            // }

            this.getSessionInfo();

            this.platform.ready().then(() => {
                this.OV = new OpenVidu();
                if (this.platform.is('cordova') && this.platform.is('android')) {
                    this.openViduSrv.checkAndroidPermissions().then(() => {
                        navigator.mediaDevices.ondevicechange = (ev) => {
                            this.initDevices();
                        };
                        this.initPublisher().then(() => this.initDevices()).then(() => this.join()).catch((error) => console.log(error));
                    }).catch((err) => {
                        console.log(err);
                        this.dismiss();
                    });
                } else {
                    this.initPublisher().then(() => this.initDevices()).then(() => this.join()).catch((error) => console.log(error));
                }
            });
        });
    }

    getSessionInfo() {
        //this.coachService.getCoachSessionInfo(this.sessionId).then((data) => {
        //  this.currentSession = data;
        this.currentParticipant = this.currentSession.delegate.full_name;
        this.currentParticipantId = this.currentSession.delegate.id;
        this.currentCoach = this.currentSession.coach.full_name;
        this.currentCoachId = this.currentSession.coach.id;
        this.currentUserId = this.userInfo.id;
        this.selfName = this.currentParticipantId === this.currentUserId ? this.currentParticipant : this.currentCoach;
        this.selfRole = this.currentParticipantId === this.currentUserId ? 'delegate' : 'coach';
        this.otherName = this.currentParticipantId !== this.currentUserId ? this.currentParticipant : this.currentCoach;
        this.otherRole = this.currentParticipantId !== this.currentUserId ? 'delegate' : 'coach';

        this.checkSessionTime();
        //});
    }

    checkSessionTime() {
        let start_at = new Date(this.currentSession.start_at);
        let end_at = new Date(this.currentSession.end_at);
        let now = new Date();
        let diff = start_at.getTime() - now.getTime()

        if (diff > 10 * 60 * 1000) {
            this.nav.back();
        } else if (diff > 0) {
            this.initTimer(Math.round(diff / 1000));
        } else if (end_at < now) {
            this.exitSession();
        } else {
            this.runSession = true;
            this.initSessionTimer();
        }
    }


    // start

    initDevices() {
        return this.OV.getDevices().then((devices: any) => {
            console.log('initDevices', devices)
            this.audioDevices = devices.filter(
                (device) => device.kind === "audioinput"
            );
            this.videoDevices = devices.filter(
                (device) => device.kind === "videoinput"
            );
            if (this.platform.is("cordova")) {
                if (this.platform.is("ios")) {
                    console.log("iOS platform");
                    setTimeout(() => {
                        this.refreshVideos();
                    }, 1100);
                } else if (this.platform.is("android")) {
                    console.log("Android platform");
                }
                this.localUser.setVideoSource(
                    this.videoDevices.filter((device: any) =>
                        device.label.includes("Front")
                    )[0].deviceId
                );
            }
            return;
        });
    }

    dismiss() {
        this.destroyPublisher();
    }

    initTimer(secLeft) {
        this.secTotal = 10 * 60;
        this.secLeft = secLeft;
        this.timerTrigger = false;
        setTimeout(() => {
            this.timerTrigger = true;
        });

        this.timerTimeout = setTimeout(() => {
            this.runSession = true;
            this.join();
        }, secLeft * 1000)
    }

    onTimeOut() {
        console.log('onTimeOut');
    }

    setAudioDevice(event) {
        console.log("Setting audio device to: ", event.detail.value.label);
        this.audioDevice = event.detail.value;
        const audioSource =
            this.audioDevice.deviceId === "None"
                ? undefined
                : this.audioDevice.deviceId;
        this.localUser.setAudioActive(!!audioSource);
        this.localUser.setAudioSource(audioSource);
        if (!!audioSource) {
            this.destroyPublisher();
            this.initPublisher();
        } else {
            this.micOff();
        }
    }

    setVideoDevice(event) {
        console.log("Setting video device to: ", event.detail.value.label);
        const videoSource =
            event.detail.value.deviceId === "None"
                ? undefined
                : event.detail.value.deviceId;
        this.localUser.setVideoActive(!!videoSource);
        this.localUser.setVideoSource(videoSource);
        if (!!videoSource) {
            this.destroyPublisher();
            this.initPublisher();
        } else {
            this.camOff();
        }
    }

    camOff() {
        (<Publisher>this.localUser.getStreamManager()).publishVideo(false);
    }

    micOff() {
        (<Publisher>this.localUser.getStreamManager()).publishAudio(false);
    }

    toggleRecording() {
        this.recordingStarted = !this.recordingStarted;
        this.processRecording();
    }

    processRecording() {
        if (this.sessionStarted) {
            if (this.recordingStarted) {
                this.openViduSrv.startSessionRecodrings()
                    .then((recording) => {
                        this.recording = recording;
                    });
            } else {
                if (this.recording) {
                    this.openViduSrv.stopSessionRecodrings(this.recording.id);
                }
            }
        }
    }

    private initPublisher(): Promise<any> {
        return new Promise((resolve, reject) => {
            console.log("initialize publisher");
            const device = this.videoDevices.filter(
                (video) => video.deviceId === this.localUser.getVideoSource()
            );

            let isBackCamera = false;
            if (this.platform.is("cordova")) {
                isBackCamera = !!device[0] && device[0].label.includes("Back");
            }
            this.localUser.setIsBackCamera(isBackCamera);

            this.OV.initPublisherAsync(undefined, {
                audioSource: this.localUser.getAudioSource(),
                videoSource: this.localUser.getVideoSource(),
                publishAudio: this.localUser.isAudioActive(),
                publishVideo: this.localUser.isVideoActive(),
                mirror: !this.localUser.isBackCamera(),
            })
                .then((publisher: Publisher) => {
                    this.localUser.setStreamManager(publisher);
                    resolve(publisher);
                })
                .catch((error) => reject(error));
        });

    }

    private destroyPublisher() {
        console.log("Destroying publisher...");
        if (this.localUser.getStreamManager() && this.localUser.getStreamManager().stream) {
            if (!!this.localUser.getStreamManager().stream.getWebRtcPeer()) {
                this.localUser.getStreamManager().stream.disposeWebRtcPeer();
            }
            this.localUser.getStreamManager().stream.disposeMediaStream();
            this.localUser.setStreamManager(null);
        }
    }

    join() {
        if (this.runSession) {
            this.initApp();
            this.showAwaitUser = true;

            let end_at = new Date(this.currentSession.end_at);
            let now = new Date();
            let diff = end_at.getTime() - now.getTime();

            this.initSessionTimer();

            if (diff > 0) {
                this.exitSessionTimeout = setTimeout(() => {
                    this.exitSessionOnExpire();
                }, diff);
            }
        }
    }


    initSessionTimer() {
        if (this.runSession) {
            let end_at = new Date(this.currentSession.end_at);
            let now = new Date();
            let diff = end_at.getTime() - now.getTime();

            this.sessionSecTotal = this.currentSession.duration * 60;
            this.sessionSecLeft = Math.floor(diff / 1000);
        }
    }

    // end
    initApp() {
        this.localUser.setType("local");
        this.checkAudioButton();
        this.checkVideoButton();
        this.remoteUsers = [];
        this.openviduLayout = new OpenViduLayout();
        this.openviduLayoutOptions = {
            maxRatio: 3 / 2, // The narrowest ratio that will be used (default 2x3)
            minRatio: 9 / 16, // The widest ratio that will be used (default 16x9)
            fixedRatio:
                true /* If this is true then the aspect ratio of the video is maintained
      and minRatio and maxRatio are ignored (default false)*/,
            bigClass: "OV_big", // The class to add to elements that should be sized bigger
            bigPercentage: 0.82, // The maximum percentage of space the big ones should take up
            bigFixedRatio: false, // fixedRatio for the big ones
            bigMaxRatio: 3 / 2, // The narrowest ratio to use for the big elements (default 2x3)
            bigMinRatio: 9 / 16, // The widest ratio to use for the big elements (default 16x9)
            bigFirst: false, // Whether to place the big one in the top left (true) or bottom right
            animate: false, // Whether you want to animate the transitions
        };
        this.openviduLayout.initLayoutContainer(
            document.getElementById("layout"),
            this.openviduLayoutOptions
        );
        if (this.platform.is("cordova") && this.platform.is("ios")) {
            setInterval(() => {
                this.updateLayout();
            }, 1000);
        }

        this.joinToSession();
    }

    // begin of chat

    joinToSession() {
        //this.OV = new OpenVidu();
        this.session = this.OV.initSession();
        this.subscribeToUserChanged();
        this.subscribeToStreamCreated();
        this.subscribedToStreamDestroyed();
        this.subscribedToChat();
        this.connectToSession();
    }

    destroySession() {
        if (this.session) {
            this.session.disconnect();
            this.sessionStarted = false;
        }
    }

    exitSessionOnExpire() {
        const now = new Date();
        const end_at = new Date(this.currentSession.end_at);

        console.log('exitSessionOnExpire', this.remoteUsers.length, end_at <= now)

        if (!this.remoteUsers.length && end_at <= now) {
            this.exitSession();
        }
    }

    exitSession() {
        this.destroySession();
        //this.destroyPublisher();
        //this.remoteUsers = [];
        //this.session = null;
        //this.localUser = null;
        //this.OV = null;
        //this.openviduLayout = null;
        this.router.navigate(["/videochat/complete"]);
    }

    resetVideoSize() {
        const element = document.querySelector("." + this.BIG_ELEMENT_CLASS);
        if (element) {
            element.classList.remove(this.BIG_ELEMENT_CLASS);
            this.bigElement = undefined;
            this.updateLayout();
        }
    }

    checkVideoButton() {
        if (this.localUser.isVideoActive()) {
            this.camBtnIcon = "videocam";
            this.camBtnColor = "light";
        } else {
            this.camBtnIcon = "eye-off";
            this.camBtnColor = "primary";
        }
    }

    checkAudioButton() {
        if (this.localUser.isAudioActive()) {
            this.micBtnIcon = "mic";
            this.micBtnColor = "light";
        } else {
            this.micBtnIcon = "mic-off";
            this.micBtnColor = "primary";
        }
    }

    micStatusChanged(): void {
        this.localUser.setAudioActive(
            !this.localUser.getStreamManager().stream.audioActive
        );
        (<Publisher>this.localUser.getStreamManager()).publishAudio(
            this.localUser.isAudioActive()
        );
        this.checkAudioButton();
        this.disableMic = !this.disableMic;
    }

    camStatusChanged(): void {
        this.localUser.setVideoActive(
            !this.localUser.getStreamManager().stream.videoActive
        );
        (<Publisher>this.localUser.getStreamManager()).publishVideo(
            this.localUser.isVideoActive()
        );
        this.checkVideoButton();
        this.disableVid = !this.disableVid;
    }

    toggleCamera() {
        if (this.platform.is("cordova")) {
            if (this.videoDevices && this.videoDevices.length > 0) {
                let videoSource: any;
                // Select the first different device
                videoSource = this.videoDevices.filter(
                    (device) => device.deviceId !== this.localUser.getVideoSource()
                )[0];
                console.log("SETTING DEVICE: ", videoSource);
                this.localUser.setVideoSource(videoSource.deviceId);

                this.localUser.setIsBackCamera(!this.localUser.isBackCamera());
                this.session.unpublish(<Publisher>this.localUser.getStreamManager());

                const publisher = this.OV.initPublisher(undefined, {
                    videoSource: this.localUser.getVideoSource(),
                    publishAudio: this.localUser.isVideoActive(),
                    publishVideo: this.localUser.isVideoActive(),
                    mirror: !this.localUser.isBackCamera(),
                });

                this.cameraBtnColor =
                    this.cameraBtnColor === "light" ? "primary" : "light";
                this.localUser.setStreamManager(null);
                setTimeout(() => {
                    this.localUser.setStreamManager(publisher);
                    this.updateLayout();
                    this.session.publish(publisher);
                });
            }
        }
    }

    async toggleChat() {
        this.buttonsVisibility = "out";
        this.chatNotification = "out";
        const modal = await this.modalController.create({
            component: ChatComponent,
            componentProps: {user: this.localUser},
        });

        modal.onWillDismiss().then(() => {
            this.modalIsPresented = false;
            this.toggleButtons();
            this.updateLayout();
        });

        return await modal.present().then(() => {
            this.modalIsPresented = true;
            this.chatBtnColor = "light";
        });
    }

    public toggleButtons() {
        this.buttonsVisibility = this.buttonsVisibility === "in" ? "out" : "in";
        this.chatNotification = this.buttonsVisibility;
    }

    public toggleButtonsOrEnlargeStream(event) {
        event.preventDefault();
        event.stopPropagation();
        const path = event.path || event.composedPath();
        const element: HTMLElement = path.filter(
            (e: HTMLElement) => e.className && e.className.includes("OT_root")
        )[0];
        if (this.bigElement && element === this.bigElement) {
            this.toggleButtons();
        } else if (this.bigElement !== element) {
            if (this.bigElement) {
                this.bigElement.classList.remove(this.BIG_ELEMENT_CLASS);
            } else {
                this.toggleButtons();
            }
            element.classList.add(this.BIG_ELEMENT_CLASS);
            this.bigElement = element;
        }
        this.updateLayout();
    }

    private deleteRemoteStream(stream: Stream): void {
        const userStream = this.remoteUsers.filter(
            (user: UserModel) => user.getStreamManager().stream === stream
        )[0];
        const index = this.remoteUsers.indexOf(userStream, 0);
        if (index > -1) {
            this.remoteUsers.splice(index, 1);
        }

        this.exitSessionOnExpire();
    }

    private subscribeToUserChanged() {
        this.session.on("signal:userChanged", (event: any) => {
            const data = JSON.parse(event.data);
            console.log("signal:userChange", this.remoteUsers);
            this.remoteUsers.forEach((user: UserModel) => {
                if (user.getConnectionId() === event.from.connectionId) {
                    if (data.avatar !== undefined) {
                        user.setUserAvatar(data.avatar);
                    }
                }
            });
        });
    }

    private subscribeToStreamCreated() {
        console.log(this.session, this.OV);
        this.session.on("streamCreated", (event: StreamEvent) => {
            console.log('streamCreated', event.stream);
            const subscriber = this.session.subscribe(event.stream, undefined);
            subscriber.on("streamPlaying", (e: StreamManagerEvent) => {
                console.log(e);
                this.updateLayout();
                (<HTMLElement>(
                    subscriber.videos[0].video
                )).parentElement.classList.remove("custom-class");
            });
            const newUser = new UserModel();
            newUser.setStreamManager(subscriber);
            newUser.setConnectionId(event.stream.connection.connectionId);
            const nickname = event.stream.connection.data.split("%")[0];
            console.log(nickname);
            try {
                newUser.setNickname(JSON.parse(nickname).clientData);
            } catch (err) {
                newUser.setNickname(nickname);
            }
            newUser.setType("remote");
            newUser.setUserAvatar(this.openViduSrv.getRandomAvatar());
            console.log(newUser.connectionId);
            this.remoteUsers.push(newUser);
            this.sendSignalUserAvatar(this.localUser);
            this.buttonsVisibility = "out";
            this.chatNotification = "out";
        });
    }

    private subscribedToStreamDestroyed() {
        this.session.on("streamDestroyed", (event: StreamEvent) => {
            console.log('streamDestroyed', event.stream);
            this.deleteRemoteStream(event.stream);
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(() => {
                this.updateLayout();
            }, 20);
            event.preventDefault();
        });
    }

    private subscribedToChat() {
        this.session.on("signal:chat", (event: any) => {
            console.log('signal:chat', event.data);
            const data = JSON.parse(event.data);
            const messageOwner =
                this.localUser.getConnectionId() === data.connectionId
                    ? this.localUser
                    : this.remoteUsers.filter(
                        (user) => user.getConnectionId() === data.connectionId
                    )[0];

            // this.messageList.push({
            //   connectionId: data.connectionId,
            //   message: data.message,
            //   userAvatar: messageOwner.getAvatar(),
            // });
            // ChatComponent.prototype.scrollToBottom();

            if (!this.modalIsPresented) {
                this.chatBtnColor = "secondary";
                //this.messageReceived = true;
                this.chatNotification = "in";
            }
        });
    }

    private sendSignalUserAvatar(user: UserModel): void {
        const data = {
            avatar: user.getAvatar(),
        };
        const signalOptions: SignalOptions = {
            data: JSON.stringify(data),
            type: "userChanged",
        };
        this.session.signal(signalOptions);
    }

    private connectToSession(): void {
        this.openViduSrv
            .getToken(this.mySessionId)
            .then((token) => {
                this.connect(token);
                this.disableMic = false;
                this.disableVid = false;
            })
            .catch((error) => {
                console.error(
                    "There was an error getting the token:",
                    error.code,
                    error.message
                );
                this.openAlertError(error.message);
            });
    }

    private connect(token: string): void {
        this.session
            .connect(token, {clientData: this.myUserName})
            .then(() => {
                this.connectWebCam();
                this.sessionStarted = true;
                this.processRecording();
            })
            .catch((error) => {
                console.error(
                    "There was an error connecting to the session:",
                    error.code,
                    error.message
                );
                this.openAlertError(error.message);
            });
    }

    private connectWebCam(): void {
        this.localUser.setNickname(this.myUserName);
        this.localUser.setConnectionId(this.session.connection.connectionId);
        console.log(this.session.connection.connectionId);
        console.log();
        this.session.publish(<Publisher>this.localUser.getStreamManager());
        console.log();
        this.localUser.getStreamManager().on("streamPlaying", () => {
            (<HTMLElement>(
                this.localUser.getStreamManager().videos[0].video
            )).parentElement.classList.remove("custom-class");
            this.updateLayout();
        });
        this.localUser.setUserAvatar(this.openViduSrv.getRandomAvatar());
        this.sendSignalUserAvatar(this.localUser);
        this.updateLayout();
    }

    private updateLayout() {
        this.resizeTimeout = setTimeout(() => {
            // Block layout update functionality
            if (false && this.openviduLayout) {
                this.openviduLayout.updateLayout();
                if (this.platform.is("cordova") && this.platform.is("ios")) {
                    console.log(this.streamComponentRemotes);
                    setTimeout(() => {
                        if (this.streamComponentLocal) {
                            this.streamComponentLocal.videoComponent.applyIosIonicVideoAttributes();
                        }
                        if (this.streamComponentRemotes.length > 0) {
                            this.streamComponentRemotes.forEach((stream: StreamComponent) => {
                                stream.videoComponent.applyIosIonicVideoAttributes();
                            });
                        }
                    }, 250);
                }
            }
        }, 20);
    }

    private refreshVideos() {
        if (this.platform.is("ios") && this.platform.is("cordova")) {
            cordova.plugins.iosrtc.refreshVideos();
        }
    }

    private async openAlertError(message: string) {
        const alert = await this.alertController.create({
            header: "Error occurred!",
            subHeader: "There was an error connecting to the session:",
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    // end of chat

    isSidebarOpened() {
        return (
            this.showDocs || this.showChat || this.showNotes || this.showSettingUp
        );
    }

    onDocClick() {
        this.showChat = !this.showChat;
    }

    openSettingUp() {
        this.hideWidePanel();
        this.showSettingUp = true;
    }

    closeSettingUp() {
        this.showSettingUp = false;
        this.checkSessionTime();
    }

    hideWidePanel() {
        this.showDocs = false;
        this.showNotes = false;
        this.showChat = false;
        this.showSettingUp = false;
    }

    ngOnDestroy() {
        console.log('VideoChatPage.ngOnDestroy')
        clearTimeout(this.timerTimeout);
        clearTimeout(this.exitSessionTimeout);
        this.destroySession();
        this.destroyPublisher();
    }
}
